var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.134,
    height: 19.137,
    viewBox: "0 0 19.134 19.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M845,254.828v-.523a2.672,2.672,0,0,1,.863-1.338q3.554-3.537,7.093-7.093a2.683,2.683,0,0,1,1.349-.874h.523a2.631,2.631,0,0,1,1.334.863q3.548,3.565,7.119,7.119a2.539,2.539,0,0,1,.852,1.364v.448a.805.805,0,0,0-.034.086,1.747,1.747,0,0,1-1.738,1.45h-.28v.25c0,1.85,0,3.7,0,5.546a2.038,2.038,0,0,1-1.435,1.913c-.116.037-.235.064-.355.1H856.85a.659.659,0,0,1-.445-.714c.007-1.424,0-2.848,0-4.275a.942.942,0,0,0-1.024-1.02H853.8a.953.953,0,0,0-1.065,1.058c0,1.413,0,2.825,0,4.238a.662.662,0,0,1-.445.714h-3.438c-.015-.007-.03-.026-.049-.026a2.1,2.1,0,0,1-1.756-2.152c.026-1.8.007-3.6.007-5.4v-.232c-.131,0-.235,0-.34,0a1.714,1.714,0,0,1-1.517-.96A3.636,3.636,0,0,1,845,254.828Z",
    transform: "translate(-845 -245)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3cdd669b681bc97c5ccdad288442dd32.svg";
export { ForwardRef as ReactComponent };